import React from 'lib/react';
import {
  EVPaper,
  EVGrid,
} from 'lib/components';
import useMediaQuery from 'hooks/useMediaQuery';
import ReportDetailsStyles from 'commonComponents/reportDetails/ReportDetailsStyles';
import SkeletonLoader from 'commonComponents/skeletonLoader';
import ReportsChangeStyles from './ReportsChangeStyles';

function ReportsChangeLoader() {
  const reportDetailsClasses = ReportDetailsStyles();
  const reportsChangeClasses = ReportsChangeStyles();
  const isMobile = useMediaQuery(640);

  const skeleton1 = <SkeletonLoader height="30px" width="139px" />;
  const skeleton2 = <SkeletonLoader height="20px" width="337px" />;
  const skeleton3 = <SkeletonLoader height="24px" width="120px" />;
  const imageSkeleton = <SkeletonLoader height="400px" width="400px" />;
  const buttonSkeleton = <SkeletonLoader height="44px" width="120px" />;

  return (
    <EVPaper square={isMobile} className={reportsChangeClasses.mainPaper}>
      <EVGrid className={reportsChangeClasses.detailsMapGrid}>
        <EVGrid className={reportDetailsClasses.detailsGrid}>
          <EVGrid className={reportDetailsClasses.detailsHeader}>
            {skeleton1}
            {skeleton2}
          </EVGrid>
          <EVGrid container className={reportDetailsClasses.detailsContent}>
            <EVGrid className={reportDetailsClasses.detailsContentContainer}>
              {skeleton3}
              {skeleton3}
            </EVGrid>
            <EVGrid className={reportDetailsClasses.detailsContentContainer}>
              {skeleton3}
              {skeleton3}
            </EVGrid>
            <EVGrid className={reportDetailsClasses.detailsContentContainer}>
              {skeleton3}
              {skeleton3}
            </EVGrid>
            <EVGrid className={reportDetailsClasses.detailsContentContainer}>
              {skeleton3}
              {skeleton3}
            </EVGrid>
            <EVGrid className={reportDetailsClasses.detailsContentContainer}>
              {skeleton3}
              {skeleton3}
            </EVGrid>
          </EVGrid>
        </EVGrid>
        <EVGrid className={reportsChangeClasses.topImage}>
          {imageSkeleton}
        </EVGrid>
      </EVGrid>
      <EVGrid className={reportsChangeClasses.linksAndBtn}>
        {buttonSkeleton}
      </EVGrid>
    </EVPaper>
  );
}

export default ReportsChangeLoader;
